import { useCallback, useEffect, useState } from "react";
import { getAllEntities } from "../../currency/infrastructure/currency.api";
import { CurrencyEntity } from "../../currency/domain/currency.entity";

export function useDefaultCurrency() {
  const [defaultCurrency, setDefaultCurrency] = useState<string>("EUR");
  const [loading, setLoading] = useState<boolean>(true);

  const loadDefaultCurrency = useCallback(async () => {
    setLoading(true);
    try {
      const currencies = await getAllEntities();
      const primary = currencies.find((c: CurrencyEntity) => c.primary);
      if (primary) {
        setDefaultCurrency(primary.code);
      }
    } catch (error) {
      console.error("Error loading default currency:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadDefaultCurrency().catch(console.error);
  }, [loadDefaultCurrency]);

  return {
    defaultCurrency,
    loading,
    reload: loadDefaultCurrency,
  };
}
